export default __webpack_public_path__ + "static/media/phone-blue.6d2d99a4.svg";